<p>{{ 'reporting_CONSUMER_HELP_TEXT' | translate }}</p>
<div class="btn-group" role="group">
    <button
        class="text-center btn btn-outline-primary"
        (click)="setPreferredType('ConsumerAttachments')">
        <h5 class="pb-3">{{ 'reporting_UPLOAD_FILE' | translate }}</h5>
        <i class="bi bi-upload"></i>
    </button>
    <button
        class="text-center btn btn-outline-primary"
        (click)="setPreferredType('ConsumerReporting')">
        <h5 class="pb-3">{{ 'reporting_MANUAL_CONSUMER_INPUT' | translate }}</h5>
        <i class="bi bi-keyboard"></i>
    </button>
</div>
